export default {
  payCancel: '支付被取消',
  payError: '支付发生错误，请稍后再试'
}
